import {
  IconInfoCircle,
} from '@tabler/icons-react';

interface Props {
  message: string,
}

export default function Alert(props: Props) {
  const { message } = props;
  return (
    <div className="rounded-md bg-blue-100 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <IconInfoCircle className="h-5 w-5 text-blue-700" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-blue-900">{message}</p>
        </div>
      </div>
    </div>
  );
}
